// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"AirlineSeat__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/AirlineSeat.scss
 ** module id = 873
 ** module chunks = 1
 **/